import React, { useState, useEffect } from 'react';
import react from '../../Resources/tech_stack/react.png';
import mysql from '../../Resources/tech_stack/mysql.png';
import node from '../../Resources/tech_stack/nodejs.png';
import python from '../../Resources/tech_stack/python.png';
import Typewriter from 'typewriter-effect';

const About = () => {
  // State for scroll position
  const [scrollY, setScrollY] = useState(0);

  // Update scroll position on scroll event
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Calculate background position based on scroll
  const backgroundPosition = `center ${scrollY * 0.1}px`; // Adjust the multiplier for the desired lag effect

  return (
    <div className="about_main" id="about">
      <h1>
        <Typewriter
          options={{
            strings: ['About me'],
            autoStart: true,
            loop: true,
            cursor: " _",
            delay: 80,
            pauseFor: 5000,
          }}
        />
      </h1>
      <div className="about_card_container">
        <div className="about_cards">
          Hello! I'm Sadhguna Aithal, a Full Stack Developer with a keen interest in building secure websites.  
          I specialize in leveraging technology to safeguard data while ensuring the applications are visually appealing and user-friendly.  
        </div>
        <div className="about_cards">
          Beyond coding, I’m a devoted mandolin artist. Music fuels my creativity, and I believe art and technology 
          are two sides of the same coin when it comes to innovation.
        </div>
        <div className="about_cards">
          I value collaboration and thrive in environments that encourage growth and learning. Let’s connect and 
          bring innovative ideas to life together!
        </div>
      </div>
      <h1>Technologies I am familiar with</h1>

      <div className="skills_container" style={{ backgroundPosition: backgroundPosition }}>
        <div className="skills_content">
          <div className="about_skill_row">
            <p>
              React is my go-to front-end technology and I have used it in most of my projects due to its versatile nature and compatibility with other technologies.
            </p>
            <img src={react} alt='React'/>
          </div>
          <div className="about_skill_row">
            <img src={node} alt='NodeJS'/>
            <p>
              Node JS is a familiar technology with which I have worked with extensively. Due to its lightweight nature, it is suitable for most use cases.
            </p>
          </div>
          <div className="about_skill_row">
            <p>
              Python is the language I use to solve DSA :)
              <br />
              I have also used Python for ML projects as well as some Native Window projects.
            </p>
            <img src={python} alt='Python'/>
          </div>
          <div className="about_skill_row">
            <img src={mysql} alt='MySQL'/>
            <p>
              MySQL is a basic yet robust DBMS. Use cases skyrocket as most problems can be solved with the right tables. 
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
